<template>
  <button
    @click="updateCurrentTopic(topic)"
    class="TopicButton btn"
    :class="[getCurrentTopic.topicName === topic.topicName ? 'active' : '']"
  >
    <img :src="logoSrc" />
    <span>{{ topic.displayName }}</span>
  </button>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

export default {
  name: 'TopicsButton',
  props: {
    topic: Object,
  },
  methods: {
    ...mapActions(['updateCurrentTopic']),
  },
  computed: {
    ...mapGetters(['getCurrentTopic']),
    logoSrc() {
      let image;
      try {
        image = require(`../assets/img/topic_logos/${this.topic.topicName}.svg`);
      } catch (error) {
        console.log(error);
        return;
      }
      return image;
    },
  },
};
</script>

<style lang="scss" scoped>
.TopicButton {
  display: flex;
  align-items: center;
  margin: 7px;
  background-color: $color-white;
  color: $color-grey;
  img {
    width: 20px;
    margin-right: 8px;
  }
  &.btn {
    font-size: 14px;
    font-weight: 500;
    padding: 7px 14px;
    border: 1px solid $color-white;
  }
  &.active {
    border: 1px solid $color-purple;
    color: $color-purple;
  }
}

@media screen and (max-width: 650px) {
  .TopicButton {
    padding: 5px 15px;
    &.btn {
      font-weight: 500;
      font-size: 14px;
      margin: 7px;
      padding: 7px 14px;
    }
  }
}
</style>
